export const UserQueryKeys = {
  User: 'user',
};
